import React from "react";
import { Link } from "react-router-dom";
import {
  Baby, HeartPulse, Heart, Flower2, ShieldCheck, Sun, Stethoscope,
  Award, UserRound, HeartHandshake, MessagesSquare, CalendarCheck, Sparkles,
} from "lucide-react";

const ICONS = {
  Baby, HeartPulse, Heart, Flower2, ShieldCheck, Sun, Stethoscope,
  Award, UserRound, HeartHandshake, MessagesSquare, CalendarCheck, Sparkles,
};

export function ServiceIcon({ name, className = "h-6 w-6" }) {
  const Icon = ICONS[name] || Stethoscope;
  return <Icon className={className} aria-hidden="true" />;
}

export function Overline({ children, className = "" }) {
  return <span className={`overline ${className}`}>{children}</span>;
}

export function SectionHeading({ overline, title, subtitle, center = false, light = false, className = "" }) {
  return (
    <div className={`${center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"} ${className}`}>
      {overline && <Overline className={light ? "text-rose" : ""}>{overline}</Overline>}
      <h2 className={`mt-4 font-serif text-3xl leading-tight tracking-tight md:text-4xl lg:text-5xl ${light ? "text-cream" : "text-charcoal"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-5 text-base leading-relaxed md:text-lg ${light ? "text-cream/70" : "text-taupe"}`}>{subtitle}</p>
      )}
    </div>
  );
}

export function CTABand() {
  return (
    <section className="relative overflow-hidden bg-terracotta">
      <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-cream/10" />
      <div className="pointer-events-none absolute -bottom-20 -left-10 h-72 w-72 rounded-full bg-terracotta-dark/40" />
      <div className="container-clinic relative flex flex-col items-center gap-8 py-16 text-center md:py-24">
        <Sparkles className="h-8 w-8 text-cream/80" aria-hidden="true" />
        <h2 className="max-w-3xl font-serif text-3xl leading-tight text-cream md:text-4xl lg:text-5xl">
          Thoughtful, personal care — whenever you are ready
        </h2>
        <p className="max-w-xl text-base leading-relaxed text-cream/80">
          Request an appointment online or speak directly with our clinic team. We are here to listen.
        </p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link
            to="/appointment"
            data-testid="ctaband-book-btn"
            className="rounded-full bg-cream px-8 py-4 font-sans text-sm font-semibold text-terracotta shadow-soft transition-transform duration-300 hover:-translate-y-0.5 active:scale-95"
          >
            Book an Appointment
          </Link>
          <Link
            to="/contact"
            data-testid="ctaband-contact-btn"
            className="rounded-full border border-cream/60 px-8 py-4 font-sans text-sm font-semibold text-cream transition-colors duration-300 hover:bg-cream/10"
          >
            Send an Enquiry
          </Link>
        </div>
      </div>
    </section>
  );
}
